import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/membros/plano-30-dias")({
  head: () => ({ meta: [{ title: "Plano 30 dias — Projeto 101" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: PlanPage,
});

const weeks = [
  { w: "Semana 1", t: "Preparação", desc: "Estruturar oferta, definir precificação, abrir MEI se aplicável e comprar materiais mínimos." },
  { w: "Semana 2", t: "Primeiros clientes", desc: "Ativar rede próxima, panfletagem, redes sociais e agendar os primeiros 3 a 5 atendimentos." },
  { w: "Semana 3", t: "Ajustes", desc: "Revisar preço, tempo, custos reais e criar rotina semanal de captação." },
  { w: "Semana 4", t: "Escala inicial", desc: "Buscar 10 atendimentos semanais, sistematizar processo, colher depoimentos e planejar o próximo mês." },
];

function PlanPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold">Plano de Ação de 30 dias</h1>
        <p className="mt-1 text-sm text-[var(--gray-ink)]">
          Roteiro semanal para os primeiros 30 dias de operação.{" "}
          <em>[Conteúdo demonstrativo — versão final em breve.]</em>
        </p>
      </div>
      <div className="space-y-3">
        {weeks.map((x) => (
          <div key={x.w} className="rounded-2xl border border-black/5 bg-white p-5">
            <p className="text-xs font-semibold uppercase tracking-wide text-[var(--green)]">{x.w}</p>
            <h3 className="mt-1 font-display text-lg font-extrabold">{x.t}</h3>
            <p className="mt-1 text-sm text-[var(--gray-ink)]">{x.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
